module.exports = __webpack_public_path__ + "static/bathmirror-97b264121cb43aeb261752a08637504a.jpeg";